import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface TabletFrameProps {
    children: ReactNode
    tilt?: boolean
    className?: string
}

// A premium landscape tablet drawn in CSS: charcoal body, thin bezel, glass sheen and a soft floor shadow.
export const TabletFrame: FC<TabletFrameProps> = ({ children, tilt = false, className }): ReactNode => {
    return (
        <div className={cn('relative [perspective:1600px]', className)}>
            <div
                className={cn(
                    'relative rounded-[22px] bg-[linear-gradient(145deg,#3A3A3A,#1F1F1F_40%,#121212)] p-[10px] shadow-[0_40px_80px_-30px_rgb(0_0_0/0.8),0_0_0_1px_rgb(244_247_250/0.08)_inset] transition-transform duration-700 ease-out sm:p-3',
                    tilt && 'lg:[transform:rotateY(-8deg)_rotateX(4deg)]'
                )}
            >
                <div className='@container relative overflow-hidden rounded-[12px] ring-1 ring-black/60'>
                    {children}

                    <div
                        aria-hidden
                        className='pointer-events-none absolute inset-0 bg-[linear-gradient(120deg,rgb(255_255_255/0.07),transparent_35%)]'
                    />
                </div>

                <span aria-hidden className='absolute top-1/2 left-[4px] size-1.5 -translate-y-1/2 rounded-full bg-soft-white/15' />
            </div>

            <div
                aria-hidden
                className='mx-auto mt-3 h-4 w-[80%] rounded-[50%] bg-black/45 blur-xl'
            />
        </div>
    )
}
